<template>
  <div class="toplogin">
    <form accept-charset="utf-8" id="login" method="post" v-on:submit="login($event)">
      <b-container>
        <b-row>
          <b-col xs="12" sm="12" md="6" lg="2" xl="2" class="mb-2 px-2 d-flex align-self-center">
            <div class="input-group">
              <div class="input-group-prepend">
                <label class="input-group-text" for="usr">
                  <i class="fas fa-user-alt"></i>
                </label>
              </div>
              <input
                autofocus
                class="form-control"
                id="username"
                name="username"
                placeholder="ชื่อ Username"
                required
                type="text"
                v-model="loginForm.username"
                :disabled="formDisabled"
              />
            </div>
          </b-col>
          <b-col xs="12" sm="12" md="6" lg="2" xl="2" class="mb-2 px-2 d-flex align-self-center">
            <div class="input-group">
              <div class="input-group-prepend">
                <label class="input-group-text" for="pwd">
                  <i class="fas fa-unlock-alt"></i>
                </label>
              </div>
              <input
                class="form-control"
                id="password"
                name="password"
                placeholder="รหัสผ่าน"
                required
                type="password"
                v-model="loginForm.password"
                :disabled="formDisabled"
              />
            </div>
          </b-col>
          <b-col
            xs="12"
            sm="12"
            md="12"
            lg="2"
            xl="2"
            class="mb-2 mb-sm-2 mb-md-2 mb-lg-0 px-2 d-flex flex-row flex-sm-row flex-md-row flex-lg-column justify-content-between align-items-center align-items-lg-start"
          >
            <div class="custom-control custom-checkbox my-0 mr-sm-1">
              <input
                type="checkbox"
                name="remember"
                value
                class="class custom-control-input"
                id="customControlInline"
                v-model="loginForm.isRememberMe"
              />
              <label class="custom-control-label" for="customControlInline">จำฉันไว้ในระบบ</label>
            </div>
            <router-link to="/forgot-password/step-1">
              <i class="fas fa-key"></i> ลืมรหัสผ่าน
            </router-link>
          </b-col>
          <b-col cols="6" sm="6" md="3" lg="2" xl="2" class="d-flex align-self-center px-2 py-1">
            <v-select
              :options="options"
              v-model="langSelected"
              :clearable="false"
              class="w-100 bg-white rounded"
              label="title"
            >
              <template v-slot:selected-option="option">
                <img class="flag-icon mr-2" :src="option.cardImage" />
                {{ option.title }}
              </template>
              <template slot="option" slot-scope="option">
                <img class="flag-icon mr-2" :src="option.cardImage" />
                {{ option.title }}
              </template>
            </v-select>
          </b-col>
          <b-col cols="6" sm="6" md="3" lg="2" xl="2" class="d-flex align-self-center px-2 py-1">
            <router-link class="btn btn-dark btn-block pb-1" to="/register/step-1">
              <i class="fas fa-user-check"></i> สมัครสมาชิก
            </router-link>
          </b-col>
          <b-col
            cols="12"
            sm="12"
            md="6"
            lg="2"
            xl="2"
            class="d-flex align-self-center px-2 pt-1 pb-0 pb-sm-1"
          >
            <button class="btn btn-gold btn-block px-2" v-if="!formDisabled">เข้าสู่ระบบ</button>
            <button class="btn btn-gold btn-block px-2" v-else>
              <b-spinner small label="Small Spinner" type="grow"></b-spinner>
            </button>
          </b-col>
        </b-row>
      </b-container>
    </form>
  </div>
</template>

<script>
import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
export default {
  name: "TopLogin",
  data() {
    return {
      loginForm: {
        username: null,
        password: null,
        isRememberMe: false
      },
      formDisabled: false,
      langSelected: {
        value: "TH",
        title: "ไทย",
        cardImage: require("../assets/flags/4x3/th.svg")
      },
      options: [
        {
          value: "TH",
          title: "ไทย",
          cardImage: require("../assets/flags/4x3/th.svg")
        },
        // {
        //   value: "EN",
        //   title: "English",
        //   cardImage: require("../assets/flags/4x3/gb.svg")
        // },
        // {
        //   value: "LA",
        //   title: "ລາວ",
        //   cardImage: require("../assets/flags/4x3/la.svg")
        // }
      ]
    };
  },
  methods: {
    ...mapActions({
      setAccessToken: "setAccessToken",
      setCustomerType: "setCustomerType",
      setCashAmount: "setCashAmount",
      setUsername: "setUsername"
    }),
    login(e) {
      e.preventDefault();
      console.log(this.loginForm);
      this.formDisabled = true;
      const options = {
        url: this.getApiUrl + "/auth/login",
        method: "POST",
        data: this.loginForm
      };

      axios(options)
        .then(response => {
          this.$bvToast.show("example-toast");
          console.log("asss");
          this.$router.push({ name: "Member" });

          if (response.data.statusCode == 400) {
      
            console.log("failed", response);
            this.formDisabled = false;
            this.loginForm.username = null;
            this.loginForm.password = null;
            this.$bvToast.toast("ยูเซอร์เนมหรือรหัสผ่านผิด", {
              title: "เข้าสู่ระบบ",
              variant: "danger",
              solid: true,
              appendToast: true
            });
            console.log("failed3", response);
          } else {
            this.formDisabled = false;
            console.log("username2", this.loginForm.username);

            this.setAccessToken([
              response.data.data.token,
              this.loginForm.username
            ]).then(() => {
              this.setCashAmount(response.data.data.cashAmount);
              this.setCustomerType(response.data.data.type);
              this.$router.push({ name: "Member" });
            });
            this.loginForm.username = null;
            this.loginForm.password = null;
            console.log("success", response);
          }
        })
        .catch(function(error) {
          // console.log("err", error);
        });
    }
  },
  computed: {
    ...mapGetters({
      getAccessToken: "getAccessToken",
      getUsername: "getUsername",
      getCashAmount: "getCashAmount",
      getApiUrl: "getApiUrl"
    })
  }
};
</script>

<style lang="scss" scoped>
.toplogin {
  font-family: Sukhumvit;
  line-height: auto;
  display: block;
  width: 100%;
  border: 1px #f5bd70 solid;
  border-radius: 5px;
  background-color: black;
  padding-top: 15px;
  padding-bottom: 10px;
  margin-top: 10px;
  color: blanchedalmond;
  box-shadow: black 0 0 5px;

  a {
    color: blanchedalmond;
    text-decoration: none;
  }

  .btn-gold {
    display: inline-block;
    outline: none;
    font-family: SukhumvitBold;
    font-size: 1em;
    box-sizing: border-box;
    border: none;
    border-radius: 0.3em;
    height: auto;
    line-height: 1.9em;
    text-transform: uppercase;
    padding: 3px 0;
    box-shadow: 0 3px 6px rgb(0 0 0 / 16%), 0 3px 6px rgb(110 80 20 / 40%),
      inset 0 -1px 2px 1px rgb(139 66 8), inset 0 -1px 1px 2px rgb(250 227 133);
    background-image: linear-gradient(
      160deg,
      #a54e07,
      #b47e11,
      #fef1a2,
      #bc881b,
      #a54e07
    );
    border: 1px solid #a55d07;
    color: rgb(120, 50, 5);
    text-shadow: 0 2px 2px rgb(250 227 133);
    cursor: pointer;
    transition: all 0.2s ease-in-out;
    background-size: 100% 100%;
    background-position: center;
  }

  .flag-icon {
    background-size: contain;
    background-position: 50%;
    background-repeat: no-repeat;
    position: relative;
    display: inline-block;
    width: 1.33333333em;
    line-height: 1em;
  }
}
</style>
